// extracted by mini-css-extract-plugin
export var formContainer = "_gw-0";
export var message = "_gw-1";